import axiosInstance from 'service/axiosInstance';
import { normalizeApiError } from 'utils/normalizeApiError';

export interface DeleteWorkStatusResponse {
  status: boolean;
  message: string;
}

export const deleteWorkStatus = async (
  projectUuid: string,
  workStatusUuid: string
): Promise<DeleteWorkStatusResponse> => {
  try {
    const { data } = await axiosInstance.delete<{ response: DeleteWorkStatusResponse }>(
      `/pmo/project/${projectUuid}/delete-project-work-status/${workStatusUuid}`
    );

    if (!data.response?.status) {
      throw new Error(data.response?.message || 'Failed to delete column');
    }

    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
